import React from 'react';
import MuiTextField from '@material-ui/core/TextField';

export default function TextField(props) {
    return <MuiTextField {...props} />;
}
